import React, { useEffect, useState } from 'react';
import {
    FormControl,
    MenuItem,
    Select,
    Typography,
    Card,
    CardContent,
    Grid,
    CircularProgress
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import UserPermission from '../../components/UserPermission';
import ControlButtons from "./ControlButtons.js";
import { exportXLSX, exportPDF, exportHTML } from './utils/Export/';
import SelectDateRange from '../../components/SelectDateRange/index.js';
import RadioGroup from './RadioGroup.js';
import { getAreas, getExecutors, getNeighborhoods, getComplaints, getServices, getControladores} from './utils';
import { endOfDay, format as formatDate, startOfDay } from 'date-fns';
import MultiManual from '../../components/Manual/MultiManual';
import api from '../../services/api.js';

const classes = {
    textTitle: {
        margin: 8,
        color: '#103168',
        fontFamily: 'Rawline',
        fontWeight: 650,
        marginBottom: 30,
    },
    root: {
        margin: '20px',
        boxShadow: 'none'
    },
    labelInput: {
        color: '#333333',
        fontFamily: 'Rawline',
        fontWeight: 'bold',
        paddingLeft: 2,
        fontSize: 14,
        marginBottom: '0.5rem'
    },
}

/* Permissão do usuário no sistema */
const userPermission = UserPermission();

export default function Reports(props) {
    const location = useLocation();

    const [typeFilter, setTypeFilter] = useState(location.state.typeFilter);

    /*Estado dos filtros*/
    const [range, setRange] = useState({
        startDate: new Date(2021, 0, 1),
        endDate: new Date()
    });

    const [format, setFormat] = useState("PDF");

    const [loading, setLoading] = useState(false);

    /*Estados que podem não ser usados*/
    const [statusOccurrence, setStatusOccurrence] = useState(null);
    const [neighborhoodOccurrence, setNeighborhoodOccurrence] = useState(null);
    const [serviceOccurrence, setServiceOccurrence] = useState(null);
    const [executorOccurrence, setExecutorOccurrence] = useState(null);
    const [areaOccurrence, setAreaOccurrence] = useState(null);
    const [controladorOccurrence, setControladorOccurrence] = useState(null);

    /*Varíaveis que irá armazenar os executores e bairros disponíveis*/
    const [neighborhoods, setNeighborhoods] = useState([]);
    const [serviceType, setServiceType] = useState([]);

    const [executors, setExecutors] = useState([]);
    const [areas, setAreas] = useState([]);
    const [controladores, setControladores] = useState([]);

    const [allStatuses, setAllStatuses] = useState([]);

    useEffect(() => {
        getNeighborhoods({ additionalProps: { order: "name" }, userPermission, callback: setNeighborhoods });
        getServices({callback: setServiceType})

        getExecutors({ additionalProps: { order: "name" }, userPermission, callback: setExecutors });

        getAreas({ additionalProps: { order: "name" }, userPermission, callback: setAreas });

        getControladores({ additionalProps: { order: "name" }, userPermission, callback: setControladores });

    }, []);

    useEffect(() => {
        if (location.state.typeFilter === 'status') {
            async function getAllStatuses(){
                try{
                    const response = await api.get(`/complaint-statuses`)
                    setAllStatuses(response.data)
                    console.log(response.data)
                }catch{
                    console.log('Erro ao buscar categorias')
                }
            }
            getAllStatuses()
        }
    },[location.state.typeFilter])

    useEffect(() => {
        setTypeFilter(location.state.typeFilter);
        setRange({
            startDate: new Date(2021, 0, 1),
            endDate: new Date()
        });

        console.log(location.state.typeFilter)

        if (location.state.typeFilter === "status") {
            setStatusOccurrence("Todos");
        } else {
            setStatusOccurrence(null);
        }

        if (location.state.typeFilter === "neighborhood") {
            setNeighborhoodOccurrence("Todos");
        } else {
            setNeighborhoodOccurrence(null);
        }

        if (location.state.typeFilter === "service") {
            setServiceOccurrence("Todos");
        } else {
            setServiceOccurrence(null);
        }

        if (location.state.typeFilter === "area") {
            setAreaOccurrence("Todos");
        } else {
            setAreaOccurrence(null);
        }

        if (location.state.typeFilter === "executor") {
            setExecutorOccurrence("Todos");
        } else {
            setExecutorOccurrence(null);
        }

        if (location.state.typeFilter === "controlador") {
            setControladorOccurrence("Todos");
        } else {
            setControladorOccurrence(null);
        }
    }, [location.state.typeFilter]);

    function neighborhoodFilter() {
        return (
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography style={classes.labelInput}>
                    Selecione o Bairro:
                </Typography>

                <FormControl fullWidth variant="outlined">
                    <Select
                        value={neighborhoodOccurrence}
                        onChange={(e) => { setNeighborhoodOccurrence(e.target.value); }}
                        style={{ 'background': '#fff' }}
                    >
                        <MenuItem value="Todos">Todos</MenuItem>
                        {
                            neighborhoods.map(name => (
                                <MenuItem key={name} value={name}>{name}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>

            </Grid>
        );
    }


    function serviceFilter() {
        return (
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography style={classes.labelInput}>
                    Selecione o Serviço de destino:
                </Typography>

                <FormControl fullWidth variant="outlined">
                    <Select
                        value={serviceOccurrence}
                        onChange={(e) => { setServiceOccurrence(e.target.value); }}
                        style={{ 'background': '#fff' }}
                    >
                        <MenuItem value="Todos">Todos</MenuItem>
                        {
                            serviceType.map(name => (
                                <MenuItem key={name} value={name}>{name}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>

            </Grid>
        );
    }

    function executorFilter() {
        return (
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography style={classes.labelInput}>
                    Selecione o Executor Responsável:
                </Typography>

                <FormControl fullWidth variant="outlined">
                    <Select
                        value={executorOccurrence}
                        onChange={(e) => { setExecutorOccurrence(e.target.value); }}
                        style={{ 'background': '#fff' }}
                    >
                        <MenuItem value="Todos">Todos</MenuItem>
                        {
                            executors.map((name, key) => (
                                <MenuItem key={key} value={name}>{name}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>
        );
    }

    function controladorFilter() {
        return (
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography style={classes.labelInput}>
                    Selecione o Controlador Responsável:
                </Typography>

                <FormControl fullWidth variant="outlined">
                    <Select
                        value={controladorOccurrence}
                        onChange={(e) => { setControladorOccurrence(e.target.value); }}
                        style={{ 'background': '#fff' }}
                    >
                        <MenuItem value="Todos">Todos</MenuItem>
                        {
                            controladores.map((name, key) => (
                                <MenuItem key={key} value={name}>{name}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>
        );
    }

    function areaFilter() {
        return (
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography style={classes.labelInput}>
                    Selecione a Área:
                </Typography>

                <FormControl fullWidth variant="outlined">
                    <Select
                        value={areaOccurrence}
                        onChange={(e) => { setAreaOccurrence(e.target.value); }}
                        style={{ 'background': '#fff' }}
                    >
                        <MenuItem value="Todos">Todos</MenuItem>
                        {
                            areas.map(name => (
                                <MenuItem key={name} value={name}>{name}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>
        );
    }

    function statusFilter() {
        return (
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography style={classes.labelInput}>
                    Selecione o Status:
                </Typography>

                <FormControl fullWidth variant='outlined'>
                    <Select
                        value={statusOccurrence}
                        onChange={(e) => { setStatusOccurrence(e.target.value); }}
                        style={{ 'background': '#fff' }}
                    >
                        <MenuItem value="Todos">Todos</MenuItem>
                        {allStatuses.map((status) => (
                            <MenuItem key={status.id} value={status.name}>{status.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        );
    }

    function dateRangeFilter() {
        return (
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <SelectDateRange
                    title={'Selecione o Período das Ocorrências'}
                    range={range}
                    setRange={setRange}
                />
            </Grid>
        );
    }

    function choiceFormat() {
        return (
            <Grid container spacing={2} justifyContent='center' alignItems='center' style={{ marginTop: '30px' }}>
                <Grid  id="checkFormat" item >
                    <RadioGroup format={format} setFormat={setFormat} />
                </Grid>
            </Grid>
        );
    }

    function getAttributeForOrganize() {
        if (['status', 'tempoAtendimento', 'tempoResolucao'].includes(typeFilter))
            return statusOccurrence === 'Todos' ? 'status' : 'neighborhood';

        //Atendidas/Abertas não têm mais filtro de status próprio (apenas data), assim como Homologadas
        if (['homologadas', 'atendidas', 'abertas'].includes(typeFilter))
            return executorOccurrence === 'Todos' ? 'status' : 'neighborhood';

        if (typeFilter === 'neighborhood')
            return neighborhoodOccurrence === 'Todos' ? 'neighborhood' : 'status';

        if (typeFilter === 'service')
            return neighborhoodOccurrence === 'Todos' ? 'neighborhood' : 'status';

        if (typeFilter === 'area')
            return areaOccurrence === 'Todos' ? 'area' : 'status';

        if (typeFilter === 'executor')
            return executorOccurrence === 'Todos' ? 'executorName' : 'status';

        if (typeFilter === 'controlador')
            return controladorOccurrence === 'Todos' ? 'controladorName' : 'status';

    }

    function getBeautifulName() {
        const beautifulNames = {
            'status': 'Status',
            'atendidas': 'Ocorrências Atendidas',
            'abertas': 'Ocorrências Abertas',
            'homologadas': 'Ocorrências Homologadas',
            'neighborhood': 'Bairro',
            'area': 'Área',
            'executor': 'Executor Responsável',
            'controlador': 'Controlador Responsável',
            'tempoAtendimento': 'Tempo de Atendimento',
            'tempoResolucao': 'Tempo de Resolução',
            'service': 'Serviço de destino'
        }

        return beautifulNames[typeFilter];
    }

    function createFilename() {
        return 'Relatório Conecta Canaã - ' +
            formatDate(new Date(), 'dd/MM/yyyy') +
            ' - Relatório por ' + getBeautifulName();
    }

    function exportReport(occurrences) {
        console.log(occurrences)
        try {

            if (format === "PDF")
                exportPDF(occurrences, getAttributeForOrganize(),
                    false, getBeautifulName(), createFilename(),
                    typeFilter === 'tempoAtendimento', typeFilter === 'tempoResolucao');
            else if (format === "HTML")
                exportHTML(occurrences, getAttributeForOrganize(),
                    false, getBeautifulName(), createFilename(),
                    typeFilter === 'tempoAtendimento', typeFilter === 'tempoResolucao');
            else
                exportXLSX(occurrences, getAttributeForOrganize(),
                    false, createFilename(),
                    typeFilter === 'tempoAtendimento', typeFilter === 'tempoResolucao');
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    function getStatusFilter() {
        if (typeFilter === 'status' && statusOccurrence !== 'Todos')
            return { status: statusOccurrence };

        if (typeFilter === 'tempoAtendimento') {
            return { status: 'Resolvido' };
        }

        if (typeFilter === 'tempoResolucao') {
            return { status: 'Em análise' };
        }

        if (typeFilter === 'atendidas')
            return { or: [{ status: 'Resolvido' }, { status: 'Indeferido' }] };

        if (typeFilter === 'abertas')
            return { or: [{ status: 'Em análise' }, { status: 'Novo' }] };
    }

    function handleSubmit() {
        setLoading(true);

        getComplaints({
            userPermission,
            callback: exportReport,
            where: {
                ...getStatusFilter(),
                complaintTarget: serviceOccurrence,
                executorName: executorOccurrence,
                controladorName: controladorOccurrence,
                neighborhood: neighborhoodOccurrence,
                area: areaOccurrence,
                createdAt: {
                    between: [
                        startOfDay(range.startDate),
                        endOfDay(range.endDate)
                    ]
                }
            }
        });
    }

    function loadingElement() {
        return (
            <div style={{ textAlign: 'center' }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <>
            <Card style={classes.root}>
                <CardContent style={{ backgroundColor: '#F5F5F5' }}>
                    <Typography variant="h5" align="center" style={classes.textTitle}>
                        Filtrar ocorrências por {getBeautifulName()}
                    </Typography>

                    <Grid id={"containerForm"} container justifyContent='center' spacing={2} style={{ paddingTop: '30px' }}>

                    {neighborhoodOccurrence && neighborhoods ? neighborhoodFilter() : false}

                    
                    {serviceOccurrence && serviceType ? serviceFilter() : false}

                    {executorOccurrence && executors ? executorFilter() : false}

                    {controladorOccurrence && controladores ? controladorFilter() : false}

                    {areaOccurrence && areas ? areaFilter() : false}

                    {statusOccurrence ? statusFilter() : false}

                    {dateRangeFilter()}

                    </Grid>

                    {choiceFormat()}


                    {loading ? loadingElement() : false}

                    <Grid container justifyContent='center' spacing={2} style={{ padding: 20 }}>
                        <ControlButtons issueReport={handleSubmit} />
                    </Grid>
                </CardContent>


                {/* 'status': 'Status',
            'atendidas': 'Ocorrências Atendidas',
            'abertas': 'Ocorrências Abertas',
            'homologadas': 'Ocorrências Homologadas',
            'neighborhood': 'Bairro',
            'area': 'Área',
            'executor': 'Executor Responsável',
            'tempoAtendimento': 'Tempo de Atendimento',
            'tempoResolucao': 'Tempo de Resolução', */}

            <MultiManual
                components={[
                    {
                        id: 'containerForm',
                        message: `Aqui você pode usar o filtro desejado`, 
                        padding: 0
                    },
                    {
                        id: 'checkFormat',
                        message: `Aqui você selecionar o tipo do arquivo`, 
                        padding: 20
                    },
                    {
                        id: 'cancelButton',
                        message: `Aqui você pode fazer a emissão`, 
                        padding: 0
                    },
                    {
                        id: 'emitirButton',
                        message: `Aqui você pode emitir o relatório`,
                        padding: 0
                    }
                    
                ]}
                />

            </Card >
        </>


    );
}